// extracted by mini-css-extract-plugin
export default {"wrapper":"Mx-z","addressLine":"Nx-z","fullName":"Ox-z"};